import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TestCase,
  TestCaseBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (response: TestCase) => void
  onError?: (error: Error) => void
  children?: (response: TestCase) => ReactElement
  params: TestCaseBody
  modelId: string
}

const CreateModelerModelTestCaseRequest = ({
  onSuccess,
  onError,
  children,
  params,
  modelId
}: Props) => {
  const url = `${MODELER_SERVICE}/models/${modelId}/test_cases`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateModelerModelTestCaseRequest
